import { BaseView } from './BaseView';
import { Message } from './Message';
import { registerSchema } from './transform';
import type { IMediaItem } from './Media';

export class ConversationItem {
  Id: number = 0;
  DateCreated: Date = new Date();
  Text: string = '';
  IsFromMe: boolean = false;
  PhotoThumbnailUrl?: string | null = null;
  PhotoFullSizeUrl?: string | null = null;
  Media?: IMediaItem | null = null;
}

export class ConversationView extends BaseView {
  MessageId: number = 0;
  Message?: Message = new Message();
  ConversationItems: ConversationItem[] = [];
}

registerSchema(ConversationItem, {
  DateCreated: 'date',
});

registerSchema(ConversationView, {
  Message: Message,
  ConversationItems: [ConversationItem],
});
